"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BurgerMenuTabNames = void 0;
let BurgerMenuTabNames = exports.BurgerMenuTabNames = /*#__PURE__*/function (BurgerMenuTabNames) {
  BurgerMenuTabNames["ProductsTab"] = "products-tab";
  BurgerMenuTabNames["AccountTab"] = "account-tab";
  return BurgerMenuTabNames;
}({});